import { Button, Flex, Text } from '@/primitives'
import ZoneUtils from '@/Util/ZoneUtils'
import useOrgLabel from '@/hooks/useOrgLabel'

import history from '../../../../history'
import { useDashboardParams } from '../../utils/useDashboardParams'

import { useDashboard } from '../context'
import { Strings, get404String } from './string'

export default function Zone404() {
  const params = useDashboardParams()
  const { state } = useDashboard()
  const orgLabel = useOrgLabel(['site', 'facility', 'room', 'zone', 'subzone'])
  const strings = Strings()

  const depth = params.zone.split('/').length - 1
  const zoneDepthString = ZoneUtils.getZoneDepthIdentifierFromDepth(depth)
  const zoneString = get404String(orgLabel[zoneDepthString]?.text)

  const handleGoBack = e => {
    e.preventDefault()
    if (!state.hierarchy) {
      history.push('/zones')
    } else {
      history.goBack()
    }
  }

  return (
    <Flex
      direction='column'
      alignCrossAxis='center'
      alignMainAxis='center'
      style={{ width: '100%', flexGrow: 1 }}
    >
      <Text as='h2'>
        {params.sensorId && strings.device404}
        {!params.sensorId && zoneString}
      </Text>
      <Button variant='primary' tone={500} onClick={handleGoBack}>
        {strings.goBack}
      </Button>
    </Flex>
  )
}
